export const SelectedLocationMarkerSvg = ({ width, height }) => {
  return (
    <svg
      width="26"
      height="34"
      viewBox="0 0 26 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8797 32.5509L11.8795 32.5507C10.1433 30.2804 8.37643 27.7476 6.6318 25.0238C4.74769 22.0751 3.37706 19.6045 2.47865 17.5321C1.57813 15.4549 1.1665 13.8102 1.1665 12.5044C1.1665 9.30444 2.34176 6.53986 4.67601 4.26231L4.67613 4.26219C7.00903 1.98442 9.84898 0.833008 13.1409 0.833008C16.4676 0.833008 19.325 1.98542 21.6577 4.26299L21.6578 4.26304C23.9912 6.54061 25.1665 9.30523 25.1665 12.5052C25.1665 13.8114 24.7548 15.4568 23.8547 17.534C22.9568 19.6063 21.587 22.0762 19.7046 25.0228C17.9608 27.7444 16.1746 30.2807 14.3949 32.5632C14.0978 32.9406 13.6346 33.1663 13.1409 33.1663H13.1321C12.6347 33.1635 12.1715 32.9329 11.8797 32.5509Z"
        fill="white"
        stroke="currentColor"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="26"
        height="34"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1311 33.6663C12.4812 33.6632 11.8703 33.3624 11.4823 32.8544C9.73678 30.5719 7.96193 28.0275 6.21067 25.2933C2.42753 19.3727 0.666504 15.3108 0.666504 12.5044C0.666504 9.16714 1.898 6.27428 4.32683 3.90444C6.75403 1.5346 9.7197 0.333008 13.1409 0.333008C16.5954 0.333008 19.579 1.5346 22.007 3.90523C24.435 6.27507 25.6665 9.16793 25.6665 12.5052C25.6665 15.3124 23.9055 19.3759 20.1256 25.2925C18.3743 28.0259 16.5791 30.5751 14.7888 32.8711C14.396 33.3711 13.7867 33.6663 13.1409 33.6663H13.1311Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.10254 8.59604C7.99957 9.69684 7.44727 10.9865 7.44727 12.5048C7.44727 14.0492 7.99387 15.3326 9.118 16.4294C10.2429 17.527 11.5582 18.0603 13.1403 18.0603C14.7224 18.0603 16.0376 17.527 17.1626 16.4294C18.2867 15.3318 18.8341 14.0484 18.8341 12.5048C18.8341 10.9611 18.2875 9.677 17.1626 8.58017C16.0384 7.48255 14.7232 6.94922 13.1411 6.94922C11.5842 6.94922 10.2641 7.48811 9.10254 8.59604Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export default SelectedLocationMarkerSvg;
